import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StatementApiResponse, StatementPeriodType } from '../../../../lib/models/fundamental/types';
import { RootState } from '../../../../lib/store';
import { getStatements } from '../../../../lib/store/fundamental';

import BalanceSheetChart from './Charts/BalanceSheetChart';
import CashFlowChart from './Charts/CashFlowChart';
import IncomeChart from './Charts/IncomeChart';

import styles from './Financials.module.scss';

type Props = {
    symbol: string;
};

const Financials = (props: Props) => {
  const { symbol } = props;
  const dispatch = useDispatch();

  const statements = useSelector<RootState, StatementApiResponse>(
    (state: RootState) => state.fundamental.statementsData,
  );

  useEffect(() => {
    dispatch(getStatements({
      symbol,
      periodType: StatementPeriodType.ANNUAL,
    }));
  }, [dispatch, symbol]);

  return (
    <div>
      <div className={styles.financialsWrapper}>
        <div className={styles.chart}>
          <IncomeChart symbol={symbol} />
        </div>
        <div className={styles.chart}>
          <BalanceSheetChart symbol={symbol} />
        </div>
        <div className={styles.chart}>
          <CashFlowChart symbol={symbol} />
        </div>
      </div>
    </div>
  );
};

export default Financials;
